import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Shield, Search, Map, Brain } from 'lucide-react';
const values = [{
  icon: <Target className="w-8 h-8 text-ice-500" data-id="element-124" />,
  title: 'Development First',
  description: 'We prioritize long-term growth over short-term wins. Teaching players to be the best teammate and represent their community to the highest standard.'
}, {
  icon: <Users className="w-8 h-8 text-ice-500" data-id="element-125" />,
  title: 'Family Centered Advisory',
  description: 'Your family is part of our team. We ensure everyone is educated, informed, and comfortable with every decision made along the journey.'
}, {
  icon: <Shield className="w-8 h-8 text-ice-500" data-id="element-126" />,
  title: 'Truth Over Hype',
  description: "Honest evaluations and real expectations. We don't waste players' or families' time with false promises."
}, {
  icon: <Search className="w-8 h-8 text-ice-500" data-id="element-127" />,
  title: 'Player ID & Evaluation',
  description: "Detailed camps, comprehensive assessments, and actionable recommendations to identify exactly what's needed for the next level."
}, {
  icon: <Map className="w-8 h-8 text-ice-500" data-id="element-128" />,
  title: 'Pathway Mapping',
  description: 'We build Plan A, B, and C for every player, assisting with recruiting, team analysis, and finding the perfect league fit.'
}, {
  icon: <Brain className="w-8 h-8 text-ice-500" data-id="element-129" />,
  title: 'Mental Resilience',
  description: "Support through trades, cuts, and injuries. We've both been there and provide the guidance needed to transition and overcome adversity."
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export const MissionSection = () => {
  return <section id="mission" className="py-24 bg-navy-800 relative" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-132">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-133">
            Built <span className="text-ice-500" data-id="element-134">Different</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-300" data-id="element-135">
            Our core values dictate everything we do. We put a huge emphasis on
            teaching players to not only be the best player they can be, but the
            best person off the ice.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-136">
          {values.map((value, index) => <motion.div key={index} variants={itemVariants} className="bg-navy-900 border border-navy-700 p-8 rounded-sm hover:border-ice-500/50 transition-colors group" data-id="element-137">
              <div className="mb-6 p-3 bg-navy-800 inline-block rounded-sm group-hover:bg-ice-500/10 transition-colors" data-id="element-138">
                {value.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-139">
                {value.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-140">
                {value.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};